export default {
  template: '#color-palette',
  data: function() {
    return {
      color: null,
      currentColor: null
    }
  },
  props: ['color', 'colorChanged'],
  methods: {
    getColor: function(color) {
      if (color.heather_image_url !== null && color.heather_image_url !== '') {
        return {
          'background-color': color.hex,
          'background-image': "url(" + color.heather_image_icon_url + ")",
          'background-position': 'center',
          'background-repeat': 'no-repeat'
        };
      } else {
        return {
          'background-color': color.hex
        }
      }
    },
    changeColor: function(color) {
      this.$root.currentColor = color;
      this.$root.updateCampaignDataWithMainProductInfo();
    },
    isActiveColor: function(color) {
      return this.$root.currentColor.hex == color.hex;
    },
    hoverColor: function(color) {
      this.$root.$set('hoverDesignerColor', color);
    },
    resetHoverColor: function() {
      this.$root.$set('hoverDesignerColor', undefined);
    },
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/colorPalette.js